/** NDJSON: one JSON value per line (a state pack's rows, wire contract §2.1).
 *  Pure, so a Worker can run it as well as the page. */

/** Counts what was parsed: the decoded text's length, which the persistent
 *  pack cache bounds itself by (B4: a stand-in for its size on disk, safe
 *  for a browser that does not compress what it stores). */
export type NdjsonStats = { chars: number };

/** Parse a whole NDJSON text. Blank lines are skipped. */
export function parseNdjson(text: string, stats?: NdjsonStats): unknown[] {
  if (stats) stats.chars += text.length;
  const rows: unknown[] = [];
  for (const line of text.split("\n")) {
    const t = line.trim();
    if (t) rows.push(JSON.parse(t));
  }
  return rows;
}

/** Parse an NDJSON body AS IT ARRIVES, so parsing overlaps the download. The
 *  browser has already undone the gzip (the object's Content-Encoding). */
export async function parseNdjsonStream(body: ReadableStream<Uint8Array>, stats?: NdjsonStats): Promise<unknown[]> {
  const rows: unknown[] = [];
  const reader = body.getReader();
  const decoder = new TextDecoder();
  let rest = "";
  for (;;) {
    const { done, value } = await reader.read();
    if (value) {
      const text = decoder.decode(value, { stream: true });
      if (stats) stats.chars += text.length;
      rest += text;
      let nl = rest.indexOf("\n");
      while (nl >= 0) {
        const line = rest.slice(0, nl).trim();
        if (line) rows.push(JSON.parse(line));
        rest = rest.slice(nl + 1);
        nl = rest.indexOf("\n");
      }
    }
    if (done) break;
  }
  const tail = decoder.decode();
  if (stats) stats.chars += tail.length;
  rest += tail;
  if (rest.trim()) rows.push(JSON.parse(rest.trim()));
  return rows;
}
